import { Brand } from '../models/brand.model';

const KONOBOX = 'konobox';

/**
 * The single Konobox brand rule (KAN-163, AC-C1/C2/C4). Mirrors the kiosk (CoinSing GetBrandDocIdAsync):
 * a brand matches only when its name (or brandName) or its document ID is exactly "Konobox"
 * (trimmed, case-insensitive). "Konobox Plus", "b_kono_old" and similar do not match, and there is no fallback ID.
 * When several brands match, the one with the lowest document ID wins, whatever the input order.
 */
export function resolveKonoboxBrand(brands: Brand[] | null | undefined): Brand | null {
  const matches = (brands || []).filter(b => {
    if (!b || !b.id) return false;
    const name = String(b.name ?? (b as any).brandName ?? '').trim().toLowerCase();
    return name === KONOBOX || String(b.id).trim().toLowerCase() === KONOBOX;
  });
  if (matches.length === 0) return null;
  return matches.reduce((best, b) => (String(b.id) < String(best.id) ? b : best));
}
